import React from "react";
import Image from "next/image";
import { getCDNImageUrl } from "@/utils/Common";

const AnimatedTitleHeader = ({ text, imgSrc, titleAsH1 = false }) => {
  return (
    <div className="relative overflow-hidden bg-[#F2F2F2]">
      <div className="w-full h-[10vh] sm:h-[14vh] md:h-[26vh] flex pl-4 sm:pl-12 justify-between items-center ">
        <div className="flex justify-center items-center -ml-2 sm:-ml-0">
          <Image
            src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709289729.svg"
            width={64}
            height={72}
            className=" h-8 sm:h-14 md:h-16 relative sm:-ml-1 mb-2"
            alt="brand-logo"
          />
          {titleAsH1 ? (
            <h1 className="text-[1rem] md:text-[2.2rem] -ml-4 sm:ml-0 font-mukta font-light">
              {text}
            </h1>
          ) : (
            <p className="text-[1rem] md:text-[2.2rem] -ml-4 sm:ml-0 font-mukta font-light">
              {text}
            </p>
          )}
        </div>
        <div className="h-full flex justify-center items-center ">
          {/* Decorative header image. Kept height-driven (no fixed width box)
              so that if the source is missing/blocked it collapses invisibly,
              exactly as before — do NOT reserve a fixed box here. */}
          <img src={imgSrc} alt="" className="h-full" />
        </div>
      </div>
      <div className="h-[12vh] sm:h-[14vh] md:h-[28vh] w-[110vw] absolute top-0 left-[130%] animateLeftToRight  bg-white ">
        <img
          src={getCDNImageUrl("AnimateArrow.webp")}
          alt=""
          width={1200}
          height={300}
          className="relative  left-[-16%] sm:left-[-8%]  h-[12vh] sm:h-[14vh] md:h-[28vh] w-auto"
        />
      </div>
    </div>
  );
};

export default AnimatedTitleHeader;
